import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from '@/lib/firebase';

export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Log page view to Firebase Analytics
    logEvent('page_view', {
      page_path: location.pathname,
      page_title: document.title,
      page_location: window.location.href
    });
  }, [location]);

  return null; // This component doesn't render anything
}
